module.exports = __webpack_public_path__ + "static/media/CQY_9.15_IT_RGB_DARK.21912390.png";